module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_f_normal.6ce0e065.png";